const compact = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 2,
});
const integer = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });

export function formatUsd(amount: number): string {
  const sign = amount < 0 ? '-' : '';
  const abs = Math.abs(amount);
  return `${sign}$${abs >= 10_000 ? compact.format(abs) : integer.format(abs)}`;
}

export function formatInt(value: number): string {
  return integer.format(value);
}

export function formatPct(value: number): string {
  return `${value.toFixed(0)}%`;
}

export function formatTonnes(kg: number): string {
  return `${(kg / 1000).toFixed(1)} t`;
}

export function hoursFromNow(targetHour: number | null, nowHour: number): string {
  if (targetHour === null) return '—';
  const delta = Math.max(0, targetHour - nowHour);
  return delta < 1 ? '<1h' : `${Math.round(delta)}h`;
}
